import { useNavigate } from "react-router-dom";
import { Rating } from "../ui/Rating";
import { AppIcon } from "../ui/AppIcon";
import { GetButton } from "../ui/GetButton";

interface AppRowProps {
  id: number;
  icon: string;
  title: string;
  subtitle?: string;
  rating?: number;
  ratingCount?: string;
  price?: number;
  rank?: number;
  className?: string;
}

export function AppRow({ id, icon, title, subtitle, rating, ratingCount, price, rank, className = "" }: AppRowProps) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/app/${id}`)}
      className={`group flex cursor-pointer items-center gap-2.5 pl-4 ${className}`}
    >
      {rank !== undefined && (
        <span className="w-4 text-center text-lg font-semibold text-neutral-900">{rank}</span>
      )}

      <AppIcon src={icon} alt={title} className="my-2 h-12 w-12" />

      <div className="flex min-w-0 flex-1 items-center gap-2 self-stretch border-b border-black/10 py-2 pr-4 group-last:border-b-0">
        <div className="min-w-0 flex-1">
          <h3 className="truncate text-[15px] leading-tight text-neutral-900">{title}</h3>
          {subtitle && <p className="truncate text-xs leading-tight text-neutral-500">{subtitle}</p>}
          {rating !== undefined && (
            <div className="mt-0.5 flex items-center gap-1">
              <Rating value={rating} size={10} />
              {ratingCount && <span className="text-[11px] leading-none text-neutral-500">{ratingCount}</span>}
            </div>
          )}
        </div>
        <GetButton size="sm" label={price ? `$${price}` : "Get"} />
      </div>
    </div>
  );
}